import { AccountType } from '@cbgms/api'
import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import N from 'utils/navigation'
import QueryString from 'query-string'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'
import { PERMISSION_ONLY_ORDER_READ } from 'utils/Subscription/PermissionComposites'

export const SetupWholesalerCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()
  const [isPortal] = useHasPermission(PERMISSION_ONLY_ORDER_READ)

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <AddShoppingCartIcon />,
        content: isPortal ? t('SetupWizard.WholesalerSummary', { context: 'portal' }) : t('SetupWizard.WholesalerSummary'),
        buttonText: t('SetupWizard.WholesalerCTA'),
        actionOnClick: () => {
          const accountType: keyof typeof AccountType = 'Business'

          const query = QueryString.stringify({ IsSupplier: true, Type: accountType })
          N.push(`/accounts/new?${query}`)
        }
      }}
    />
  )
}
